var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],style:(_vm.cssVars),attrs:{"src":_vm.blok.image.filename,"alt":_vm.blok.altText || _vm.blok.image.alt || '',"loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }